import axios from "axios";
import { api } from "client.settings.json";
import { DownloadAllButton } from "components/downloadAllButton";
import ReportButton from "components/reportButton";
import PropTypes from "prop-types";
import { Fragment, useCallback, useEffect, useState } from "react";

const SubmissionPage = ({ name, tenantId, transactionId, messageId, tokens, attachments }) => {
  const [handlebars, setHandlebars] = useState([]);

  const fetchPage = useCallback(async () => {
    try {
      const res = await axios.get(`${api}/api/templates/${tenantId}/E_DELIVERY_SUBMISSION_PAGE`);
      setHandlebars(Object.values(res.data.template.handlebars));
    } catch (error) {
      console.error("Error while fetching the page:", error);
    }
  }, [tenantId]);

  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  return (
    <div style={{ padding: "20px 15px" }} className="panelContent">
      {handlebars.map((h, i) => (
        <Fragment key={i}>
          {h && (
            <div
              key={i}
              dangerouslySetInnerHTML={{
                __html: h.split("[form name]").join(`${name}`)
              }}
            />
          )}
        </Fragment>
      ))}
      <div className="d-flex mt-4">
        <ReportButton settings={{ activeItemId: transactionId }} type={"eDeliveryReport"} tokens={tokens} />
        {attachments.length > 0 && <DownloadAllButton messageId={messageId} tenantId={tenantId} tokens={tokens} />}
      </div>
    </div>
  );
};

SubmissionPage.propTypes = {
  attachments: PropTypes.array.isRequired,
  messageId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  tenantId: PropTypes.string.isRequired,
  tokens: PropTypes.object.isRequired,
  transactionId: PropTypes.string.isRequired
};

export default SubmissionPage;
